import React from 'react';
import { IItemCreationSubsectionInputProps, ItemCreationSubsection } from '~/Components';
import { ExtendedLocation } from '../ExtendedLocation.model';
import { LocationEditCustomOpeningHours } from './LocationEditCutstomSections';

export const LocationEditOpeningHoursSection = () => {
  const LocationEditOtherDetailsOpeningHours: IItemCreationSubsectionInputProps<
    Partial<ExtendedLocation>
  >[] = [
    {
      customElement: <LocationEditCustomOpeningHours />,
    },
  ];

  return (
    <div>
      <ItemCreationSubsection items={LocationEditOtherDetailsOpeningHours} />
    </div>
  );
};
